<template>
  <v-dialog
    v-model="visible"
    persistent
    max-width="550"
    min-height="550"
  >
    <v-card class="custom-dialog pa-16">
      <div class="title">
        {{ title }}
      </div>
      <v-divider class="divider" />
      <slot />
    </v-card>

    <v-snackbar
      v-model="openLocal"
      :color="snackbar.color"
      timeout="3000"
      location="top"
      multi-line
    >
      <v-icon
        class="me-2"
        size="small"
      >
        {{ icon }}
      </v-icon>
      {{ snackbar.text }}
    </v-snackbar>
  </v-dialog>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  type Snack = {
    open: boolean;
    text: string;
    color: 'success' | 'error' | 'info' | '';
  };

  const props = defineProps<{
    modelValue: boolean;
    title: string;
    snackbar: Snack;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', v: boolean): void;
    (e: 'update:snackbar', v: Snack): void;
  }>();

  const visible = computed({
    get: () => props.modelValue,
    set: (v) => emit('update:modelValue', v),
  });

  const openLocal = ref<boolean>(props.snackbar.open);

  // keep local in sync when parent opens/closes snackbar
  watch(
    () => props.snackbar.open,
    (v) => {
      openLocal.value = v;
    }
  );

  const icon = computed(() =>
    props.snackbar.color === 'success'
      ? 'mdi-check-circle'
      : props.snackbar.color === 'error'
        ? 'mdi-alert-circle'
        : 'mdi-information'
  );
</script>

<style scoped lang="sass">
  .custom-dialog
    border-radius: 16px
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08)
    background-color: white
    display: flex
    align-items: center
    justify-content: center

  .title
    font-size: 22px
    font-weight: 400
    text-align: center
    margin-bottom: 16px
    color: #1976d2

  .divider
    margin-bottom: 24px
    background-color: #e0e0e0
</style>
